import type { GridColumnCount, GridColumnLayout } from "./types";

/**
 * Grid responsive column class mapping.
 * Keep aligned with the Web 2.0 Component Library grid specs:
 * - https://www.figma.com/design/mMeNxrnlQAvk5QIjJW09rb/Web-2.0---Component-Library?node-id=12801-119
 * - https://www.figma.com/design/mMeNxrnlQAvk5QIjJW09rb/Web-2.0---Component-Library?node-id=3886-4818
 */

const GRID_COLS: Record<GridColumnCount, string> = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
};

const MD_GRID_COLS: Record<GridColumnCount, string> = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
};

const XL_GRID_COLS: Record<GridColumnCount, string> = {
  1: "xl:grid-cols-1",
  2: "xl:grid-cols-2",
  3: "xl:grid-cols-3",
  4: "xl:grid-cols-4",
};

function getGridColumnClasses(options: {
  columnCount?: GridColumnCount;
  columnLayout?: GridColumnLayout;
}): string {
  const { columnCount, columnLayout } = options;

  if (!columnLayout) {
    const count = columnCount ?? 2;
    return `grid-cols-1 ${MD_GRID_COLS[count]}`;
  }

  const classes: string[] = [];

  if (columnLayout.smallViewport !== undefined) {
    classes.push(GRID_COLS[columnLayout.smallViewport]);
  } else {
    classes.push("grid-cols-1");
  }

  if (columnLayout.mediumViewport !== undefined) {
    classes.push(MD_GRID_COLS[columnLayout.mediumViewport]);
  }

  if (columnLayout.largeViewport !== undefined) {
    classes.push(XL_GRID_COLS[columnLayout.largeViewport]);
  }

  return classes.join(" ");
}

export { getGridColumnClasses };
